export const useStartAnimations = (scope: HTMLElement | Element | null | undefined, callback: () => void) => {
    const pageComplete = usePageComplete();
    const loadComplete = useGlobalLoaded();
    const { $gsap: gsap } = useNuxtApp();
    let isMounted: boolean = false;
    let ctx: gsap.Context | undefined;

    onMounted(() => (isMounted = true));
    onUnmounted(() => {
        ctx?.revert();
    });

    watch(
        () => pageComplete.value && loadComplete.value && isMounted,
        state => {
            if (state) {
                nextTick(() => {
                    if (scope) {
                        ctx = gsap.context(() => callback(), scope);
                    } else {
                        callback();
                    }
                });
            }
        }
    );
};
